module.exports = __webpack_public_path__ + "static/media/certification.f72319f5.svg";